import type { RuleHandler } from "../types";

const checkMinStake: RuleHandler = (context, requirement) => {
  const minStake = requirement.userDrivenAttributes?.minimumStake!;

  return context.selection.stake >= minStake;
};

export { checkMinStake };
